export const ASSETS_PLUGIN_NAME = "assets";
export const ASSETS_SERVICE_NAME = `${ASSETS_PLUGIN_NAME}:assets-service`;
export const ROUTER_SERVICE_NAME = `${ASSETS_PLUGIN_NAME}:router`;
export const RPC_PROXY_SERVICE_NAME = `${ASSETS_PLUGIN_NAME}:rpc-proxy`;
export const ASSETS_KV_SERVICE_NAME = `${ASSETS_PLUGIN_NAME}:kv`;
